import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material';
import visuallyHidden from '@mui/utils/visuallyHidden';
import PropTypes from 'prop-types';

const CheckboxWithInfoTooltip = ({ id, label, helperText, checked, onChange, sx }) => {
  const helperTextId = `${id}-helper-text`;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
            inputProps={{ 'aria-describedby': helperTextId }}
          />
        }
        label={label}
        sx={{ mr: 0 }}
      />
      <Tooltip title={helperText} placement='right' arrow>
        <IconButton size='small' aria-label={`About ${label}`}>
          <InfoOutlinedIcon fontSize='small' color='action' />
        </IconButton>
      </Tooltip>
      <Box component='span' id={helperTextId} sx={visuallyHidden}>
        {helperText}
      </Box>
    </Box>
  );
};

CheckboxWithInfoTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

CheckboxWithInfoTooltip.defaultProps = {
  sx: {},
};

export default CheckboxWithInfoTooltip;
